"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { HeroGlow } from "@/components/ui";

export default function ProxyServerHero() {
  const reduced = useReducedMotion() ?? false;

  return (
    <section
      aria-labelledby="proxy-server-hero-heading"
      className="border-border pb-section-sm relative overflow-y-clip border-b pt-24 sm:pt-32"
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <HeroGlow align="center" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <motion.h1
          id="proxy-server-hero-heading"
          initial={reduced ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.08 }}
          className="text-foreground text-4xl leading-[1.1] font-bold tracking-tight sm:text-5xl lg:text-6xl"
        >
          What Is a Proxy Server? How It Works and Which Type to Choose
        </motion.h1>

        <motion.p
          initial={reduced ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="text-muted-foreground light:text-foreground/80 mx-auto mt-5 max-w-2xl text-lg leading-relaxed"
        >
          A proxy server is an intermediary that routes your traffic through its own connection.
          Here&apos;s how it works, every type explained, and how to pick the right one.
        </motion.p>
      </div>
    </section>
  );
}
